import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { onBeforeMount, useRoute } from '@nuxtjs/composition-api';
import { SButton, SIcon } from '@strana-artw/ui-kit';
import { storeToRefs } from 'pinia';
import { computed, defineComponent, onMounted } from 'vue';
import { useMainSiteLink } from '@/shared/composables';
import { HEADER_ID, ROUTE_NAMES, ROUTE_PATHS } from '@/shared/constants';
import { prettyPhoneWithParenthesis } from '@/shared/lib/utils/numberFormatters';
import { TheLogo } from '@/shared/ui';
import HoverableLink from '@/shared/ui/HoverableLink.vue';
import { useGlobalStore } from '@/store/global';
import { useMainPageStore } from '@/store/mainPage';
export default /*#__PURE__*/_defineComponent({
  __name: 'UnauthorizedHeader',
  props: {
    isLoginButtonActive: {
      type: Boolean,
      default: false
    },
    isBackLinkActive: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    defineComponent({
      name: 'UnauthorizedHeader'
    });
    var _useGlobalStore = useGlobalStore(),
      globalInit = _useGlobalStore.globalInit;
    onBeforeMount(function () {
      globalInit();
    });
    var mainPageStore = useMainPageStore();
    var _storeToRefs = storeToRefs(mainPageStore),
      manager = _storeToRefs.manager;
    onMounted(function () {
      mainPageStore.getManager();
    });
    var phone = computed(function () {
      var _manager$value;
      return (_manager$value = manager.value) === null || _manager$value === void 0 ? void 0 : _manager$value.phone;
    });
    var preparedPhone = computed(function () {
      if (!phone.value) {
        return;
      }
      return prettyPhoneWithParenthesis(phone.value);
    });
    var mainSiteLink = useMainSiteLink();
    var route = useRoute();
    var isLandingPage = computed(function () {
      return route.value.name === ROUTE_NAMES.index;
    });
    return {
      __sfc: true,
      props: props,
      globalInit: globalInit,
      mainPageStore: mainPageStore,
      manager: manager,
      phone: phone,
      preparedPhone: preparedPhone,
      mainSiteLink: mainSiteLink,
      route: route,
      isLandingPage: isLandingPage,
      SButton: SButton,
      SIcon: SIcon,
      HEADER_ID: HEADER_ID,
      ROUTE_PATHS: ROUTE_PATHS,
      TheLogo: TheLogo,
      HoverableLink: HoverableLink
    };
  }
});